(function () {
    angular.module('services.global', ['ngResource', 'feedResource', 'relatedContentResource'])
        .factory('global', global);

    global.$inject = ['$resource'];
    function global($resource) {
        return {
            careers: $resource('/api/careers', {}),
            caseStudies: $resource('/api/caseStudies'),
            featuredCaseStudies: $resource('/api/caseStudies/featured'),
            caseStudyFilters: $resource('/api/caseStudies/filters'),
            caseStudyRelatedContent: $resource('/api/caseStudies/relatedContent/:id', { id: '@id' }),
            clients: $resource('/api/main/clients'),
            events: $resource('/api/events'),
            filters: $resource('/api/main/filters/:group', { group: '@group' }),
            footerNavs: $resource('/api/main/footerNavs', {}),
            pageviews: $resource('/api/main/pageviews', {}),
            featuredBlogs: $resource('/api/blog/featured', {}),
            mostSharedBlogs: $resource('/api/blog/most-shared', {}),
            recentBlogs: $resource('/api/blog/recent', {}),
            relatedBlogs: $resource('/api/blog/related', {}),
            blogArchive: $resource('/api/blog/archive', {}),
            blogPosts: $resource('/api/blog', {}),
            blogFilters: $resource('/api/blog/filters'),
            productCategories: $resource('/api/products/categories', { pageSize: 10 }),
            productFilters: $resource('/api/products/filters'),
            products: $resource('/api/products/:id', { id: '@id' }),
            resources: $resource('/api/resources'),
            search: $resource('/api/main/search', {}),
            services: $resource('/api/services/:id', { id: '@id' }),
            serviceCategories: $resource('/api/services/categories', {}),
            sliderImages: $resource('/api/main/sliderImages/:id', { id: '@id' }),
            relatedContent: $resource('/api/main/relatedContent/:id', { id: '@id' }),
            test: $resource('/api/resources'),
        };
    }
})();